import {
  type GetVisitsRequestQuery,
  type GetVisitsWithCaseDataResponse,
  getVisitsWithCaseDataResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

const GET_VISITS_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/in-home/case/visit/`;

export const getVisitsQueryKey = [GET_VISITS_URL];

export function useGetVisitsWithCaseData(
  filter: GetVisitsRequestQuery["filter"],
  options: UseGetQueryOptions<GetVisitsWithCaseDataResponse> = {}
) {
  const queryParams: GetVisitsRequestQuery = {
    filter,
    include: ["case", "workplace"],
  };

  return useGetQuery({
    url: GET_VISITS_URL,
    queryParams,
    responseSchema: getVisitsWithCaseDataResponse,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_VISIT_DATA_FAILURE,
    },
    retry: 0,
    staleTime: 1000 * 60 * 1,
    ...options,
  });
}
